export default __webpack_public_path__ + "static/media/disable-anonymous.b3beeeaf.svg";